module.exports = __webpack_public_path__ + "img/环境评估.a57dac90.svg";